import PropTypes from 'prop-types';
import Menu01Icon from '@untitled-ui/icons-react/build/esm/Menu01';
import {Box, IconButton, Stack, SvgIcon, useMediaQuery} from '@mui/material';
import {alpha} from '@mui/material/styles';
import {AccountButton} from '../account-button';
import {ThemeSwitch} from "../theme-switch";
import {SIDE_NAV_MINI_WIDTH, SIDE_NAV_WIDTH,TOP_NAV_HEIGHT} from "src/layouts/app";
import {NotificationsButton} from "../notifications-button";
import {ChatNotifications} from "../chat-notifications";

export const TopNav = (props) => {
    const {onMobileNavOpen, openSideNav, ...other} = props;
    const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'));

    return (
        <Box
            component="header"
            sx={{
                backdropFilter: 'blur(6px)',
                backgroundColor: (theme) => alpha(theme.palette.background.default, 0.8),
                position: 'sticky',
                left: {
                    lg: `${SIDE_NAV_WIDTH}px`
                },
                top: 0,
                width: {
                    lg: `calc(100% - ${openSideNav ? SIDE_NAV_WIDTH : SIDE_NAV_MINI_WIDTH}px)`
                },
                zIndex: (theme) => 1
            }}
            {...other}>
            <Stack
                alignItems="center"
                direction="row"
                justifyContent="space-between"
                spacing={2}
                sx={{
                    minHeight: TOP_NAV_HEIGHT,
                    px: 2
                }}
            >
                <Stack
                    alignItems="center"
                    direction="row"
                    spacing={2}
                >
                    {!lgUp && (
                        <IconButton onClick={onMobileNavOpen}>
                            <SvgIcon>
                                <Menu01Icon/>
                            </SvgIcon>
                        </IconButton>
                    )}
                </Stack>
                <Stack
                    alignItems="center"
                    direction="row"
                    spacing={2}
                >
                    {/*<ChatNotifications/>*/}
                    <ThemeSwitch/>
                    <AccountButton/>
                </Stack>
            </Stack>
        </Box>
    );
};

TopNav.propTypes = {
    onMobileNavOpen: PropTypes.func
};
